import React from 'react';

import {MailVerifiedIcon} from '@src/components/icons';

import * as S from './ResetPasswordEmailSentCard.styles';

export interface ResetPasswordEmailSentCardProps {
  email: string;
  resetForm: () => void;
}

const ResetPasswordEmailSentCard = ({email, resetForm}: ResetPasswordEmailSentCardProps) => (
  <S.Wrapper>
    <MailVerifiedIcon width="92px" />
    <S.InfoTextWrapper>
      <S.Title>Check your mail</S.Title>
      <S.Email>{email}</S.Email>
      <S.InfoText>You will receive a password reset link if an account exists for this email. </S.InfoText>

      <S.FooterText>
        Didn&apos;t get an email? <span onClick={resetForm}>Resend email.</span>
      </S.FooterText>
    </S.InfoTextWrapper>
  </S.Wrapper>
);

export default ResetPasswordEmailSentCard;
